import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import TextField from "@mui/material/TextField";

import { TABLE_NAME  as tableName, splitAndTrim } from "../../../helpers";

const normalizeFilterValue = (rawValue) => {
  if (Array.isArray(rawValue)) {
    return rawValue.join(", ");
  }
  return rawValue || "";
};


const createTextColumnFilter =
  () =>
  ({ value, header, handleFilterSet }) => {
     const [updatedValue, setUpdatedValue] = useState(() => normalizeFilterValue(value));
    
    useEffect(() => {
      setUpdatedValue(normalizeFilterValue(value));
    }, [value]);

    const { t } = useTranslation();
    
    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        const newValue = e.target.value;
        if (!newValue || newValue.trim() === "") {
          handleFilterSet([]);
          setUpdatedValue("");
          return;
        }
        handleFilterSet(splitAndTrim(newValue));
         setUpdatedValue(newValue);
      }
    };

    const handleChange = (e) => {
      const newValue = e.target.value || undefined;
      setUpdatedValue(newValue);
      
      if (!newValue || newValue.trim() === "") {
        handleFilterSet([]);
      }
    };

    return (
      <TextField
        size="small"
        fullWidth
        sx={{ mb: 1 }}
        label={`Search ${tableName[header]}`}
        value={updatedValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={t('text_place_holder')}
        title={t('text_title')}
      />
    );
  };

const createTextColumnEditor =
  () =>
  ({ value, onBlur }) => {
    const [updatedValue, setUpdatedValue] = useState(value);

    useEffect(() => {
      setUpdatedValue(value);
    }, [value]);

    const handleBlur = () => {
      onBlur(updatedValue); 
    };

    return (
      <TextField
        size="small"
        fullWidth
        sx={{ mb: 1 }}
        value={updatedValue || ""}
        onChange={(e) => setUpdatedValue(e.target.value || undefined)}
        onBlur={handleBlur}
      />
    );
  };

export { createTextColumnFilter, createTextColumnEditor };